// extracted by mini-css-extract-plugin
export default {"card":"actionSelector_card__KecQl","box":"actionSelector_box__iQ7II"};